import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {UserDTO} from '../../clm/models/user/UserDTO';
import {UserRoleDTO} from '../../clm/models/user/UserRoleDTO';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {Role} from '../../clm/types/role.enum';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private url = environment.baseUrl + '/user';

  constructor(private httpClient: HttpClient) {
  }

  getListOfUsers(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<UserDTO>> {
    return this.httpClient.post<PagedResponseDTO<UserDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveUser(userDTO: UserDTO): Observable<UserDTO> {
    let url = this.url;
    const redirectOverrideUrl = this.getRedirectUrl(userDTO);
    if (redirectOverrideUrl) {
      const encodedRedirect = encodeURIComponent(redirectOverrideUrl);
      url += `?redirectUrl=${encodedRedirect}`;
    }
    return this.httpClient.post<UserDTO>(url, userDTO);
  }

  deleteUserBy(userId: bigint) {
    return this.httpClient.delete<{}>(this.url + '/' + userId);
  }

  getUserBy(userId: number): Observable<UserDTO> {
    return this.httpClient.get<UserDTO>(this.url + '/' + userId);
  }

  getUserByUsername(username: string): Observable<UserDTO> {
    return this.httpClient.get<UserDTO>(this.url + '/by-username?username=' + username);
  }

  getRoles(): Observable<UserRoleDTO[]> {
    return this.httpClient.get<UserRoleDTO[]>(this.url + '/role');
  }

  resetUserPassword(userDTO: UserDTO) {
    let url = `${this.url}/reset-password`;
    const redirectOverrideUrl = this.getRedirectUrl(userDTO);
    if (redirectOverrideUrl) {
      const encodedRedirect = encodeURIComponent(redirectOverrideUrl);
      url += `?redirectUrl=${encodedRedirect}`;
    }
    return this.httpClient.post<UserDTO>(url, userDTO);
  }

  approveUser(userDTO: UserDTO): Observable<UserDTO> {
    let url = `${this.url}/approve`;
    const redirectOverrideUrl = this.getRedirectUrl(userDTO);
    if (redirectOverrideUrl) {
      const encodedRedirect = encodeURIComponent(redirectOverrideUrl);
      url += `?redirectUrl=${encodedRedirect}`;
    }
    return this.httpClient.post<UserDTO>(url, userDTO);
  }

  private getRedirectUrl(userDTO: UserDTO): string {
    if (this.userHasRole(userDTO, Role.Provider)) {
      return environment.keycloak.redirectOverrideUrlProvider;
    } else if (this.userHasRole(userDTO, Role.OnBoardingManager)) {
      return environment.keycloak.redirectOverrideUrlOnboarding;
    } else if (this.userHasRole(userDTO, Role.Broker)) {
      return environment.keycloak.redirectOverrideUrlBroker;
    } else {
      return environment.keycloak.redirectOverrideUrlEnterprise;
    }
  }

  private userHasRole(userDTO: UserDTO, roleNameToFind: string): boolean {
    return !!userDTO.userRoles?.find(role => role.role_Name === roleNameToFind);
  }
}
